module.exports = __webpack_public_path__ + "media/images/hankyu_hakone_en01-636717d068f813e004b6438a6df833dd.jpg";